import { action } from 'typesafe-actions'
import { TrainerActionTypes } from './types'
import { ITrainerProfile } from '../interface'

// Search Request
export const listRequest = (searchParams:any) => action(TrainerActionTypes.LIST_REQUEST, searchParams)
export const listSuccess = (data: ITrainerProfile[]) => action(TrainerActionTypes.LIST_SUCCESS, data)
export const listError = (errors: any) => action(TrainerActionTypes.LIST_ERROR, errors)
export const listClear = () => action(TrainerActionTypes.LIST_CLEAR)

// Select Data
export const selectData = (id: string) => action(TrainerActionTypes.SELECT, id)
export const selectedData = () => action(TrainerActionTypes.SELECTED)
export const selectedClear = () => action(TrainerActionTypes.CLEAR_SELECTED)

// Create
export const createRequest = (doc: ITrainerProfile) => action(TrainerActionTypes.CREATE_REQUEST, doc)
export const createSuccess = (doc: ITrainerProfile) => action(TrainerActionTypes.CREATE_SUCCESS, doc) // Newly created data
export const createError = (errors: any) => action(TrainerActionTypes.CREATE_ERROR, errors)

// Read
export const readRequest = (data: ITrainerProfile) => action(TrainerActionTypes.READ_REQUEST, data)
export const readSuccess = (data: ITrainerProfile) => action(TrainerActionTypes.READ_SUCCESS, data)
export const readError = (errors: any) => action(TrainerActionTypes.READ_ERROR, errors)

// Update
export const updateRequest = (keyValues: any) => action(TrainerActionTypes.UPDATE_REQUEST, keyValues)
export const updateSuccess = (doc: ITrainerProfile) => action(TrainerActionTypes.UPDATE_SUCCESS, doc) // Updated Data
export const updateError = (errors: any) => action(TrainerActionTypes.UPDATE_ERROR, errors)

// Delete
export const deleteRequest = (doc: ITrainerProfile) => action(TrainerActionTypes.DELETE_REQUEST, doc)
export const deleteSuccess = (id: string) => action(TrainerActionTypes.DELETE_SUCCESS, id)  // Return deleted User id to remove from state
export const deleteError = (errors: any) => action(TrainerActionTypes.DELETE_ERROR, errors)
